import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const GolfIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="#001A19"
      title={t`Golf`}
      {...props}
    >
      <G fill="currentColor" clipPath={`url(#${clipPathId})`}>
        <Path d="M8 11.2c3.096 0 5.6-2.504 5.6-5.6C13.6 2.504 11.096 0 8 0a5.596 5.596 0 0 0-5.6 5.6c0 3.096 2.504 5.6 5.6 5.6Zm0-9.6c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4Z" />
        <Path d="M6.4 5.6a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6ZM9.6 5.6a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6ZM8 4a.8.8 0 1 0 0-1.6A.8.8 0 0 0 8 4ZM4 13.6h1.6c.88 0 1.6.72 1.6 1.6v.8h1.6v-.8c0-.88.72-1.6 1.6-1.6H12V12H4v1.6Z" />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
